import React from 'react';
import PropTypes from 'prop-types';

function CenteredContent(props) {

  const {
    className, show, padding, children, heightContainer,
  } = props;
  return (
    <div
      className={className}
      style={{
        padding,
        height: heightContainer || '100vh',
        display: show ? 'flex' : 'none',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {children}
    </div>
  );

}

CenteredContent.propTypes = {
  className: PropTypes.string,
  heightContainer: PropTypes.string,
  children: PropTypes.node.isRequired,
  show: PropTypes.bool,
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

CenteredContent.defaultProps = {
  className: null,
  heightContainer: null,
  show: true,
  padding: 0,
};

export default CenteredContent;
